import { useRef } from 'react';

const CLIENTS = [
  {
    name: 'Mr. Ramesh Baliga',
    role: 'CEO Watertec',
    text: 'The best company for the incentive trips for the dealers and distributors. They create Wow Factor everytime.',
    img: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&q=80&w=800&h=1200'
  },
  {
    name: 'Ms. Divya Dharshini',
    role: 'Television Artist',
    text: 'The choice of hotels they use, vehicles they provide and the quality of the vacation they curate is definitely world-class. Kudos Team GT.',
    img: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&q=80&w=800&h=1200'
  },
  {
    name: 'Mrs. Kirthika Shivkumar',
    role: 'Director - TIPS',
    text: 'We love the detailing they do in curating each trip and to be mentioned is the regular followups on-tour. Keep it up GT.',
    img: 'https://images.unsplash.com/photo-1522075469751-3a6694fb2f61?auto=format&fit=crop&q=80&w=800&h=1200'
  },
  // {
  //   name: 'Navan & Wikki',
  //   role: 'Couple',
  //   text: 'Our honeymoon trip to Spain was one of the best ever trips we have experienced. It was handled with style by Team GT.',
  //   img: 'https://images.unsplash.com/photo-1516589174184-c685265142ec?auto=format&fit=crop&q=80&w=800&h=1200'
  // },
  {
    name: 'Mr. Bimal',
    role: 'VP - Luker India',
    text: 'The Creativity they handle in their execution part is one of the most unique quality which cant be replaced by other companies',
    img: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?auto=format&fit=crop&q=80&w=800&h=1200'
  },
  {
    name: 'Mr. Ramesh Baliga',
    role: 'CEO Watertec',
    text: 'The best company for the incentive trips for the dealers and distributors. They create Wow Factor everytime.',
    img: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&q=80&w=800&h=1200'
  },
  {
    name: 'Ms. Divya Dharshini',
    role: 'Television Artist',
    text: 'The choice of hotels they use, vehicles they provide and the quality of the vacation they curate is definitely world-class. Kudos Team GT.',
    img: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&q=80&w=800&h=1200'
  },
  {
    name: 'Mrs. Kirthika Shivkumar',
    role: 'Director - TIPS',
    text: 'We love the detailing they do in curating each trip and to be mentioned is the regular followups on-tour. Keep it up GT.',
    img: 'https://images.unsplash.com/photo-1522075469751-3a6694fb2f61?auto=format&fit=crop&q=80&w=800&h=1200'
  },
  // {
  //   name: 'Navan & Wikki',
  //   role: 'Couple',
  //   text: 'Our honeymoon trip to Spain was one of the best ever trips we have experienced. It was handled with style by Team GT.',
  //   img: 'https://images.unsplash.com/photo-1516589174184-c685265142ec?auto=format&fit=crop&q=80&w=800&h=1200'
  // },
  {
    name: 'Mr. Bimal',
    role: 'VP - Luker India',
    text: 'The Creativity they handle in their execution part is one of the most unique quality which cant be replaced by other companies',
    img: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?auto=format&fit=crop&q=80&w=800&h=1200'
  }
];

export default function HappyClients() {
  const scrollRef = useRef(null);

  const scroll = (dir) => {
    if (scrollRef.current) {
      const { scrollLeft, clientWidth } = scrollRef.current;
      const scrollAmount = clientWidth * 0.8;
      const scrollTo = dir === 'left' ? scrollLeft - scrollAmount : scrollLeft + scrollAmount;
      scrollRef.current.scrollTo({ left: scrollTo, behavior: 'smooth' });
    }
  };

  return (
    <section className="happy-clients-section">
      <div className="container">
        <h2 className="section-title">Our Happy Clients</h2>

        <div className="carousel-wrapper">
          <button className="carousel-arrow prev" onClick={() => scroll('left')} aria-label="Previous">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg>
          </button>

          <div className="carousel-inner" ref={scrollRef}>
            {CLIENTS.map((c, i) => (
              <div key={i} className="client-card">
                <div className="client-img-wrapper">
                  <img src={c.img} alt={c.name} className="client-img" />
                  <div className="client-card-overlay">
                    <div className="quote-container">
                      <svg className="quote-icon-svg" width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M14.017 21L14.017 18C14.017 16.8954 14.9124 16 16.017 16H19.017C19.5693 16 20.017 15.5523 20.017 15V9C20.017 8.44772 19.5693 8 19.017 8H15.017C14.4647 8 14.017 8.44772 14.017 9V15M3.01709 21L3.01709 18C3.01709 16.8954 3.91252 16 5.01709 16H8.01709C8.56937 16 9.01709 15.5523 9.01709 15V9C9.01709 8.44772 8.56937 8 8.01709 8H4.01709C3.46481 8 3.01709 8.44772 3.01709 9V15" />
                      </svg>
                      <p className="client-testimonial">{c.text}</p>
                      <div className="client-meta">
                        <span className="name">{c.name}</span>
                        <span className="role">{c.role}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <button className="carousel-arrow next" onClick={() => scroll('right')} aria-label="Next">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>
          </button>
        </div>
      </div>
    </section>
  );
}
